import React, { Component } from 'react';

class EditContacto extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Contacto</div>
        );
    }
}
 
export default EditContacto;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditContacto.jsx